#import "../fragments/email-automation-status.graphql"

query GetEmailAutomationsNeedingAttention($limit: Int!, $cursor: String) {
    emailAutomationStatusesNeedsAttention(first: $limit, after: $cursor) {
        pageInfo {
            endCursor
            hasNextPage
        }
        edges {
            node {
                ...EmailAutomationStatus
            }
        }
    }
}
